import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { colors } from 'common/constants';
import { common } from '@mui/material/colors';
import { ReactComponent as TotalDataIcon } from 'assets/images/icons/campaign-data-analytics/tổng dữ liệu thu thập.svg';
import { ReactComponent as EligibleIcon } from 'assets/images/icons/campaign-data-analytics/đủ điều kiện.svg';
import { ReactComponent as DataCollectedForAFeeIcon } from 'assets/images/icons/campaign-data-analytics/dữ liệu thu thập có phí.svg';
import { ReactComponent as TotalNumberOfParticipantsIcon } from 'assets/images/icons/campaign-data-analytics/tổng số người tham gia.svg';
import QuestionDetail from './question-detail';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExportData from './export-data';
import { formatCurrency, handleError } from 'utils/helpers';
import {
    getCampaignAnalyticsFeedback,
    getCampaignAnalyticsQuestionFeedback,
} from 'services/campaign.service';
import { useParams } from 'react-router-dom';
import {
    ICamapaignDataAnalysisResponse,
    ICampaignDataQuestion,
} from 'types/campaign';
import { IPagination } from 'types/type.global';
import SyncIcon from '@mui/icons-material/Sync';
import { useAppSelector } from 'common/hook';
import { useTranslation } from 'react-i18next';
import { savePDF } from '@progress/kendo-react-pdf';

const Feedback: React.FC = () => {
    const { t } = useTranslation();
    const [questionId, setQuestionId] = React.useState<number>();
    const [openDialogDetailQuestion, setOpenDialogDetailQuestion] =
        React.useState(false);
    const [openDialogExportData, setOpenDialogExportData] =
        React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const campaignId = useParams<{ id: string }>().id;

    const [campaignData, setCampaignData] =
        React.useState<ICamapaignDataAnalysisResponse>();
    const currentCampaign = useAppSelector(
        (state) => state.campaignState.campaign
    );
    const [listQuestion, setListQuestion] =
        React.useState<ICampaignDataQuestion>();
    useEffect(() => {
        const getDataAnalysisFeedback = async () => {
            try {
                const response = await getCampaignAnalyticsFeedback(
                    Number(campaignId)
                );
                if (response.success) {
                    setCampaignData(response.data);
                }
            } catch (error) {
                handleError(error);
            }
        };

        getDataAnalysisFeedback();
    }, [campaignId]);

    const [loading, setLoading] = useState<boolean>(true);
    const [pagination, setPagination] = useState<IPagination>({
        page: 1,
        per_page: 3,
        total_page: null,
    });
    useEffect(() => {
        const getListQuestion = async () => {
            try {
                if (
                    pagination.total_page !== null &&
                    pagination.page > (pagination.total_page ?? 0)
                ) {
                    setLoading(false);
                    return;
                }

                const response = await getCampaignAnalyticsQuestionFeedback(
                    Number(campaignId),
                    { page: pagination.page, per_page: pagination.per_page }
                );

                if (response.success) {
                    setListQuestion((prev) => ({
                        data_question: prev
                            ? [
                                  ...prev.data_question,
                                  ...response.data.data_question,
                              ]
                            : response.data.data_question,
                        pagination: response.data.pagination,
                    }));

                    setPagination((prev) => ({
                        ...prev,
                        page: prev.page + 1,
                        total_page:
                            prev.total_page ??
                            response.data.pagination.total_page,
                    }));
                }
            } catch (error) {
                handleError(error);
                setLoading(false);
            }
        };

        setLoading(true);
        getListQuestion();
    }, [
        pagination.page,
        campaignId,
        pagination.total_page,
        pagination.per_page,
    ]);
    const container = React.useRef(null);
    const exportPDFWithMethod = () => {
        const element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 40,
            fileName: currentCampaign?.campaign,
        });
    };
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        fontSize: '28px',
                        lineHeight: '33.89px',
                        color: colors.main,
                    }}
                >
                    {currentCampaign?.campaign}
                </Typography>
                <Button
                    sx={{
                        textTransform: 'none',
                        minWidth: '177px',
                        height: '60px',
                        borderRadius: '39px',
                        padding: '0px',
                    }}
                    id="basic-button"
                    variant="contained"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    endIcon={
                        <ExpandMoreIcon
                            sx={{
                                width: 40,
                                height: 40,
                            }}
                        />
                    }
                    startIcon={
                        <FileDownloadOutlinedIcon
                            sx={{
                                fontSize: '40px !important',
                                color: 'inherit',
                            }}
                        />
                    }
                >
                    <Typography
                        fontSize={20}
                        component={'span'}
                        fontWeight={'bold'}
                        lineHeight={'24px'}
                    >
                        {t('page.campaign.button.export')}
                    </Typography>
                </Button>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    sx={{
                        '& .MuiPaper-root': {
                            borderRadius: '7px',
                            marginTop: '10px',
                            minWidth: '177px',
                        },
                    }}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem
                        className="navigate-button"
                        onClick={() => {
                            handleClose();
                            setOpenDialogExportData(true);
                        }}
                    >
                        Xuất CSV
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            exportPDFWithMethod();
                        }}
                    >
                        Xuất PDF
                    </MenuItem>
                </Menu>
            </Box>
            <Box ref={container}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        gap: 2,
                        mb: 2,
                    }}
                >
                    {[
                        {
                            icon: <TotalDataIcon />,
                            value: formatCurrency(
                                campaignData?.total_answered ?? 0
                            ),
                            label: 'Tổng dữ liệu thu thập',
                            color: 'var(--color-primary-light-40)',
                        },
                        {
                            icon: <EligibleIcon />,
                            value: formatCurrency(
                                campaignData?.total_answer_approved ?? 0
                            ),
                            label: 'Đủ điều kiện',
                            color: '#FFEEE2',
                        },
                        {
                            icon: <DataCollectedForAFeeIcon />,
                            value: formatCurrency(
                                campaignData?.total_answer_paid ?? 0
                            ),
                            label: 'Dữ liệu thu thập có phí',
                            color: '#EFFBFF',
                        },
                        {
                            icon: <TotalNumberOfParticipantsIcon />,
                            value: formatCurrency(
                                campaignData?.total_user_answered ?? 0
                            ),
                            label: 'Tổng người tham gia',
                            color: '#FFEAED',
                        },
                    ].map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'left',
                                padding: '24px',
                                backgroundColor: item.color,
                                borderRadius: '35.13px',
                            }}
                        >
                            <Box sx={{ marginBottom: 2 }}>{item.icon}</Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '37.5px',
                                    color: '#000000B2',
                                    lineHeight: '44px',
                                    marginBottom: 1.5,
                                }}
                            >
                                {item.value}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    fontWeight: 400,
                                    fontSize: '25px',
                                    color: '#000000B2',
                                    lineHeight: '44px',
                                }}
                            >
                                {item.label}
                            </Typography>
                        </Box>
                    ))}
                </Box>
                {loading && (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            gap: 1,
                            mb: 2,
                        }}
                    >
                        Đang tải dữ liệu
                        <SyncIcon
                            sx={{
                                fontSize: 36,
                                ...(loading && {
                                    animation: 'spin 2s linear infinite',
                                    '@keyframes spin': {
                                        '0%': { transform: 'rotate(360deg)' },
                                        '100%': { transform: 'rotate(0deg)' },
                                    },
                                }),
                            }}
                        />
                    </Box>
                )}
                <Box>
                    {listQuestion?.data_question.map((item, key) => (
                        <Box
                            key={key}
                            sx={{
                                backgroundColor: common.white,
                                padding: 3,
                                borderRadius: '30px',
                                mb: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    mb: 1,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '28px',
                                        lineHeight: '33.89px',
                                    }}
                                >
                                    {`Câu ${key + 1}: ${item.question_name}`}
                                </Typography>
                                <Button
                                    onClick={() => {
                                        setOpenDialogDetailQuestion(true);
                                        setQuestionId(item.question_name_id);
                                    }}
                                    variant="contained"
                                    sx={{
                                        backgroundColor: colors.main,
                                        color: common.white,
                                        borderRadius: '50px',
                                        textTransform: 'none',
                                        fontSize: '14px',
                                        fontWeight: 700,
                                    }}
                                >
                                    Xem chi tiết
                                </Button>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    mb: 1,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: '24px',
                                    }}
                                >
                                    Số phản hồi: {item.total_answered_question}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontWeight: 400,
                                        fontSize: '24px',
                                    }}
                                >
                                    Thời gian trung bình: {item.avg_duration}{' '}
                                    giây
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    mb: 2,
                                }}
                            >
                                {Array.isArray(item.data_option) &&
                                    item.data_option.length > 0 && (
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: '24px',
                                                mb: 2,
                                            }}
                                        >
                                            Tổng hợp câu trả lời :
                                        </Typography>
                                    )}
                                {Array.isArray(item.data_option) &&
                                    item.data_option.map((answer, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                mb: 1,
                                                borderBottom:
                                                    '1px solid #0000001A',
                                                ml: 2,
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    flex: 0.8,
                                                    fontSize: '18px',
                                                    mb: 1,
                                                }}
                                            >
                                                {answer.option_name}
                                            </Typography>
                                            <Box
                                                sx={{
                                                    flex: 0.2,
                                                    fontWeight: 400,
                                                    fontSize: '18px',
                                                    textAlign: 'right',
                                                    mb: 1,
                                                }}
                                            >
                                                {answer.total_respondents} phản
                                                hồi (
                                                <Typography
                                                    component={'span'}
                                                    sx={{
                                                        fontWeight: 400,
                                                        fontSize: '18px',
                                                        color: '#1B49EF',
                                                    }}
                                                >
                                                    {`${answer.rate_respondents}`}
                                                </Typography>
                                                )
                                            </Box>
                                        </Box>
                                    ))}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            {openDialogDetailQuestion && (
                <QuestionDetail
                    open={openDialogDetailQuestion}
                    onClose={() => setOpenDialogDetailQuestion(false)}
                    questionId={questionId ?? 0}
                />
            )}
            {openDialogExportData && (
                <ExportData
                    open={openDialogExportData}
                    onClose={(open) => setOpenDialogExportData(open)}
                />
            )}
        </>
    );
};
export default Feedback;
